import { MenuItem } from '@/types/menu';

import {
  OrdersIcon,
  RolesIcon,
  StoresIcon,
  DepartmentsIcon,
  FunctionsIcon,
  SheetIcon,
  PermissionIcon,
  UserIcon,
  TeamsIcon,
  SettingsIcon,
  FactoriesIcon,
} from './icon';

export const sideBarItem: MenuItem[] = [
  {
    label: 'Stores',
    route: '/stores',
    icon: StoresIcon,
  },
  {
    label: 'Orders',
    route: '/orders',
    icon: OrdersIcon,
  },
  {
    label: 'Departments',
    route: '/departments',
    icon: DepartmentsIcon,
  },
  {
    label: 'Roles',
    route: '/roles',
    icon: RolesIcon,
  },
  {
    label: 'Functions',
    route: '/functions',
    icon: FunctionsIcon,
  },
  {
    label: 'Permission',
    route: '/permission',
    icon: PermissionIcon,
  },
  {
    label: 'User',
    route: '/user',
    icon: UserIcon,
  },
  {
    label: 'Sheet',
    route: '/sheet',
    icon: SheetIcon,
  },
  {
    label: 'Fulfillment',
    route: '/fulfillment',
    icon: OrdersIcon,
  },
  {
    label: 'Factory Dashboard',
    route: '/factory/dashboard',
    icon: StoresIcon,
  },
  {
    label: 'Activity Log',
    route: '/activity-log',
    icon: PermissionIcon,
  },
  {
    label: 'Teams',
    route: '/teams',
    icon: TeamsIcon,
  },
  {
    label: 'Settings',
    route: '/settings',
    icon: SettingsIcon,
  },
  {
    label: 'Factories',
    route: '/factories',
    icon: FactoriesIcon,
  }
];
